var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{ref:"dialog",attrs:{"visible":_vm.editorShow,"title":"编辑","width":"800px"},on:{"update:visible":function($event){_vm.editorShow=$event},"close":_vm.editorClose}},[_c('EditModal',{ref:"editModal",on:{"onSubmit":_vm.onModalSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }